/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_DialectInputs */

const cs_import_dialect = /** @type {(inputs: Import_DialectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formát / dialekt`)
};

const en_import_dialect = /** @type {(inputs: Import_DialectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format / dialect`)
};

/**
* | output |
* | --- |
* | "Format / dialect" |
*
* @param {Import_DialectInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_dialect = /** @type {((inputs?: Import_DialectInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_DialectInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_dialect(inputs)
	return cs_import_dialect(inputs)
});